import { style } from 'utils/constants/style';

export const LocationPin = () => (
  <svg
    width="35"
    height="46"
    viewBox="0 0 35 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="17.5001"
      cy="40.3846"
      rx="13.4615"
      ry="5.38462"
      fill="url(#paint0_radial_5973_86538)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7858 33.7917C29.6874 31.5065 34.6667 25.0014 34.6667 17.3333C34.6667 7.7604 26.9063 0 17.3333 0C7.7604 0 0 7.7604 0 17.3333C0 25.0019 4.97993 31.5074 11.8823 33.7922L17.3339 40.3341L22.7858 33.7917Z"
      fill="url(#paint1_linear_5973_86538)"
    />
    <circle cx="17.4486" cy="17.4471" r="5.38462" fill="white" />
    <defs>
      <radialGradient
        id="paint0_radial_5973_86538"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.5001 40.3846) rotate(90) scale(5.38462 13.4615)"
      >
        <stop stopColor="#232A36" />
        <stop offset="1" stopColor="#333A44" stopOpacity="0.15" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5973_86538"
        x1="17.3333"
        y1="0"
        x2="17.3333"
        y2="40.3341"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={style.mainYellow.orangeGradientTop} />
        <stop offset="1" stopColor={style.mainYellow.yellow} />
      </linearGradient>
    </defs>
  </svg>
);

export const RouteEndPin = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5973_92063)">
      <circle cx="22" cy="17" r="16" fill={style.mainBlue.blue} />
      <circle
        cx="22"
        cy="17"
        r="16"
        stroke={style.mainWhite.white}
        strokeWidth="2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 9.71289V30.4992V9.71289Z"
      fill={style.mainWhite.white}
    />
    <path
      d="M13.5 9.71289V30.4992"
      stroke={style.mainWhite.white}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.8833 20.3787C30.8745 17.0719 30.8648 13.7652 30.8557 10.4583C30.8546 10.1004 30.7919 9.69988 30.2049 9.50424C25.6005 7.90599 21.2643 11.756 16.6598 10.1577C16.3014 10.0127 16.0116 10.1419 16.0126 10.4998C16.0217 13.8066 16.0239 17.1135 16.0402 20.4203C16.0428 20.951 16.3327 21.2294 16.6911 21.3744C21.2955 22.9727 25.6318 19.1227 30.2364 20.721C30.5946 20.8659 30.8844 20.7367 30.8833 20.3787ZM29.5598 10.5788C29.5622 11.4911 29.565 12.4035 29.5674 13.3158C28.571 13.0836 27.6458 13.0493 26.6292 13.148C26.6269 12.2357 26.6241 11.3233 26.6217 10.4111C27.6381 10.3125 28.5634 10.3466 29.5598 10.5788ZM17.3285 17.5226C17.3253 16.4859 17.3227 15.4492 17.3198 14.4126C18.3661 14.6607 19.3477 14.6826 20.4135 14.5599C20.4108 13.6475 20.4083 12.7352 20.4059 11.8228C21.4607 11.6542 22.4843 11.3881 23.5137 11.1059C23.5161 12.0182 23.5189 12.9306 23.5214 13.8429C22.492 14.1251 21.4682 14.3913 20.4135 14.5599C20.4164 15.5965 20.4192 16.6332 20.4221 17.6698C19.3563 17.7924 18.3748 17.7706 17.3285 17.5226ZM20.4299 20.4469C20.4272 19.5212 20.4247 18.5955 20.4221 17.6697C21.4695 17.5024 22.4857 17.239 23.5078 16.9587C23.5103 17.8845 23.5129 18.8102 23.5155 19.736C22.4935 20.0163 21.4772 20.2796 20.4299 20.4469ZM23.5298 16.9527C23.5271 15.9161 23.5242 14.8794 23.5214 13.8428C24.5504 13.5617 25.5728 13.3029 26.6292 13.1481C26.6322 14.1847 26.6351 15.2214 26.6379 16.2579C25.5816 16.4129 24.5589 16.6716 23.5298 16.9527ZM26.6637 19.033C26.6611 18.1073 26.6585 17.1815 26.6559 16.2557C27.666 16.1594 28.5861 16.1948 29.576 16.4258C29.5786 17.3516 29.5812 18.2773 29.5839 19.203C28.5939 18.9721 27.6737 18.9365 26.6637 19.033Z"
      fill={style.mainWhite.white}
    />
    <path
      d="M30.8833 20.3787L30.7833 20.379L30.7833 20.379L30.8833 20.3787ZM30.8557 10.4583L30.9557 10.4581L30.9557 10.458L30.8557 10.4583ZM30.2049 9.50424L30.1721 9.59872L30.1733 9.59911L30.2049 9.50424ZM16.6598 10.1577L16.6222 10.2505L16.627 10.2522L16.6598 10.1577ZM16.0126 10.4998L16.1126 10.4996L16.1126 10.4995L16.0126 10.4998ZM16.0402 20.4203L16.1402 20.4198L16.1402 20.4198L16.0402 20.4203ZM16.6911 21.3744L16.6535 21.4672L16.6583 21.4689L16.6911 21.3744ZM30.2364 20.721L30.2739 20.6282L30.2691 20.6266L30.2364 20.721ZM29.5598 10.5788L29.6598 10.5785L29.6596 10.4994L29.5825 10.4814L29.5598 10.5788ZM29.5674 13.3158L29.5447 13.4132L29.6678 13.4418L29.6674 13.3155L29.5674 13.3158ZM26.6292 13.148L26.5292 13.1483L26.5295 13.2582L26.6389 13.2475L26.6292 13.148ZM26.6217 10.4111L26.6121 10.3115L26.5215 10.3203L26.5217 10.4113L26.6217 10.4111ZM17.3285 17.5226L17.2285 17.5229L17.2287 17.6017L17.3054 17.6199L17.3285 17.5226ZM17.3198 14.4126L17.3429 14.3153L17.2194 14.286L17.2198 14.4129L17.3198 14.4126ZM20.4135 14.5599L20.4249 14.6592L20.5137 14.649L20.5135 14.5596L20.4135 14.5599ZM20.4059 11.8228L20.3901 11.7241L20.3056 11.7376L20.3059 11.8231L20.4059 11.8228ZM23.5137 11.1059L23.6137 11.1056L23.6134 10.9749L23.4873 11.0095L23.5137 11.1059ZM23.5214 13.8429L23.5478 13.9393L23.6216 13.9191L23.6214 13.8426L23.5214 13.8429ZM20.4135 14.5599L20.3977 14.4611L20.3132 14.4746L20.3135 14.5602L20.4135 14.5599ZM20.4221 17.6698L20.4335 17.7692L20.5223 17.7589L20.5221 17.6695L20.4221 17.6698ZM20.4299 20.4469L20.3299 20.4472L20.3302 20.5641L20.4456 20.5457L20.4299 20.4469ZM20.4221 17.6697L20.4063 17.5709L20.3218 17.5844L20.3221 17.67L20.4221 17.6697ZM23.5078 16.9587L23.6078 16.9584L23.6074 16.8277L23.4813 16.8623L23.5078 16.9587ZM23.5155 19.736L23.5419 19.8324L23.6157 19.8122L23.6155 19.7357L23.5155 19.736ZM23.5298 16.9527L23.4298 16.953L23.4302 17.0836L23.5562 17.0492L23.5298 16.9527ZM23.5214 13.8428L23.4951 13.7463L23.4212 13.7665L23.4214 13.8431L23.5214 13.8428ZM26.6292 13.1481L26.7292 13.1478L26.7289 13.0324L26.6147 13.0491L26.6292 13.1481ZM26.6379 16.2579L26.6524 16.3569L26.7381 16.3443L26.7379 16.2577L26.6379 16.2579ZM26.6637 19.033L26.5637 19.0333L26.564 19.1429L26.6732 19.1325L26.6637 19.033ZM26.6559 16.2557L26.6464 16.1562L26.5557 16.1648L26.5559 16.256L26.6559 16.2557ZM29.576 16.4258L29.676 16.4255L29.6757 16.3464L29.5987 16.3284L29.576 16.4258ZM29.5839 19.203L29.5611 19.3003L29.6842 19.329L29.6839 19.2027L29.5839 19.203ZM30.9833 20.3785C30.9745 17.0717 30.9648 13.7649 30.9557 10.4581L30.7557 10.4586C30.7648 13.7655 30.7745 17.0722 30.7833 20.379L30.9833 20.3785ZM30.9557 10.458C30.9552 10.2754 30.9394 10.0654 30.8385 9.87381C30.7354 9.67802 30.5503 9.51394 30.2366 9.40937L30.1733 9.59911C30.4465 9.69018 30.5863 9.82416 30.6615 9.96702C30.739 10.1141 30.7552 10.2834 30.7557 10.4587L30.9557 10.458ZM30.2377 9.40977C27.9029 8.59933 25.6383 9.17228 23.4079 9.73402C21.168 10.2981 18.9622 10.8511 16.6925 10.0632L16.627 10.2522C18.9618 11.0626 21.2264 10.4897 23.4568 9.92796C25.6967 9.36383 27.9025 8.8109 30.1721 9.59871L30.2377 9.40977ZM16.6973 10.065C16.5025 9.98619 16.3084 9.97444 16.1565 10.0508C15.9983 10.1304 15.912 10.2921 15.9126 10.5001L16.1126 10.4995C16.1122 10.3496 16.1703 10.2677 16.2464 10.2295C16.3287 10.1881 16.4587 10.1842 16.6223 10.2504L16.6973 10.065ZM15.9126 10.5001C15.9217 13.8066 15.9239 17.1139 15.9402 20.4208L16.1402 20.4198C16.1239 17.1132 16.1217 13.8066 16.1126 10.4996L15.9126 10.5001ZM15.9402 20.4207C15.9416 20.7054 16.0205 20.9294 16.1527 21.1026C16.2841 21.2747 16.4628 21.3899 16.6536 21.4671L16.7286 21.2817C16.5609 21.2139 16.4155 21.1173 16.3117 20.9813C16.2087 20.8464 16.1414 20.6658 16.1402 20.4198L15.9402 20.4207ZM16.6583 21.4689C18.9931 22.2793 21.2576 21.7064 23.4881 21.1447C25.728 20.5806 27.9339 20.0277 30.2036 20.8155L30.2691 20.6266C27.9343 19.8161 25.6697 20.389 23.4392 20.9507C21.1993 21.5148 18.9935 22.0678 16.7239 21.2799L16.6583 21.4689ZM30.1989 20.8138C30.3936 20.8925 30.5877 20.9042 30.7395 20.8278C30.8977 20.7482 30.9839 20.5865 30.9833 20.3784L30.7833 20.379C30.7838 20.529 30.7256 20.6109 30.6496 20.6491C30.5673 20.6906 30.4374 20.6944 30.2738 20.6283L30.1989 20.8138ZM29.4598 10.5791C29.461 11.0352 29.4623 11.4914 29.4636 11.9476C29.4649 12.4038 29.4662 12.8599 29.4674 13.3161L29.6674 13.3155C29.6662 12.8594 29.6649 12.4032 29.6636 11.947C29.6623 11.4908 29.661 11.0347 29.6598 10.5785L29.4598 10.5791ZM29.5901 13.2184C28.5813 12.9834 27.645 12.949 26.6196 13.0485L26.6389 13.2475C27.6466 13.1497 28.5606 13.1839 29.5447 13.4132L29.5901 13.2184ZM26.7292 13.1477C26.7269 12.2358 26.7241 11.3226 26.7217 10.4108L26.5217 10.4113C26.5241 11.3239 26.5269 12.2356 26.5292 13.1483L26.7292 13.1477ZM26.6314 10.5106C27.6389 10.4129 28.553 10.4469 29.5371 10.6762L29.5825 10.4814C28.5737 10.2463 27.6374 10.2121 26.6121 10.3115L26.6314 10.5106ZM17.4285 17.5223C17.4253 16.4857 17.4227 15.449 17.4198 14.4123L17.2198 14.4129C17.2227 15.4495 17.2253 16.4862 17.2285 17.5229L17.4285 17.5223ZM17.2967 14.5099C18.3566 14.7612 19.3501 14.783 20.4249 14.6592L20.402 14.4605C19.3453 14.5822 18.3757 14.5602 17.3429 14.3153L17.2967 14.5099ZM20.5135 14.5596C20.5108 13.6472 20.5083 12.7349 20.5059 11.8226L20.3059 11.8231C20.3083 12.7354 20.3108 13.6478 20.3135 14.5602L20.5135 14.5596ZM20.4216 11.9216C21.4823 11.752 22.5104 11.4847 23.5402 11.2023L23.4873 11.0095C22.4583 11.2916 21.4391 11.5564 20.3901 11.7241L20.4216 11.9216ZM23.4137 11.1062C23.4161 12.0184 23.4189 12.9309 23.4214 13.8432L23.6214 13.8426C23.6189 12.9302 23.6161 12.018 23.6137 11.1056L23.4137 11.1062ZM23.495 13.7465C22.4659 14.0285 21.4467 14.2934 20.3977 14.4611L20.4292 14.6586C21.4898 14.4891 22.5181 14.2216 23.5478 13.9393L23.495 13.7465ZM20.3135 14.5602C20.3164 15.5968 20.3192 16.6335 20.3221 17.6701L20.5221 17.6695C20.5192 16.6329 20.5164 15.5962 20.5135 14.5596L20.3135 14.5602ZM20.4106 17.5705C19.3539 17.6921 18.3844 17.6701 17.3516 17.4253L17.3054 17.6199C18.3652 17.8711 19.3587 17.8928 20.4335 17.7692L20.4106 17.5705ZM20.5299 20.4466C20.5272 19.521 20.5247 18.5952 20.5221 17.6694L20.3221 17.67C20.3247 18.5957 20.3272 19.5215 20.3299 20.4472L20.5299 20.4466ZM20.4379 17.7684C21.4911 17.6003 22.5118 17.3355 23.5342 17.0552L23.4813 16.8623C22.4597 17.1424 21.448 17.4046 20.4063 17.5709L20.4379 17.7684ZM23.4078 16.959C23.4103 17.8848 23.4129 18.8105 23.4155 19.7363L23.6155 19.7357C23.6129 18.8099 23.6103 17.8842 23.6078 16.9584L23.4078 16.959ZM23.489 19.6395C22.4675 19.9198 21.4557 20.1818 20.4141 20.3482L20.4456 20.5457C21.4988 20.3775 22.5195 20.1129 23.5419 19.8324L23.489 19.6395ZM23.6298 16.9525C23.6271 15.9158 23.6242 14.8792 23.6214 13.8425L23.4214 13.8431C23.4242 14.8797 23.4271 15.9164 23.4298 16.953L23.6298 16.9525ZM23.5478 13.9393C24.576 13.6584 25.5936 13.4009 26.6437 13.247L26.6147 13.0491C25.552 13.2049 24.5248 13.465 23.4951 13.7463L23.5478 13.9393ZM26.5292 13.1483C26.5322 14.185 26.5351 15.2216 26.5379 16.2582L26.7379 16.2577C26.7351 15.2211 26.7322 14.1844 26.7292 13.1478L26.5292 13.1483ZM26.6234 16.159C25.5608 16.3149 24.5333 16.575 23.5035 16.8563L23.5562 17.0492C24.5845 16.7683 25.6024 16.511 26.6524 16.3569L26.6234 16.159ZM26.7637 19.0327C26.7611 18.107 26.7585 17.1813 26.7559 16.2554L26.5559 16.256C26.5585 17.1818 26.5611 18.1076 26.5637 19.0333L26.7637 19.0327ZM26.6654 16.3553C27.6666 16.2598 28.5756 16.2951 29.5532 16.5232L29.5987 16.3284C28.5965 16.0946 27.6654 16.059 26.6464 16.1562L26.6654 16.3553ZM29.476 16.4261C29.4786 17.3518 29.4812 18.2776 29.4839 19.2032L29.6839 19.2027C29.6812 18.277 29.6786 17.3513 29.676 16.4255L29.476 16.4261ZM29.6066 19.1056C28.6044 18.8718 27.6731 18.8361 26.6542 18.9334L26.6732 19.1325C27.6744 19.0369 28.5835 19.0723 29.5611 19.3003L29.6066 19.1056Z"
      fill={style.mainWhite.white}
    />
    <defs>
      <filter
        id="filter0_d_5973_92063"
        x="0"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="2.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5973_92063"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5973_92063"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const RouteStartPin = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="16"
      r="14"
      fill={style.mainWhite.white}
      stroke={style.mainBlue.blue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="16"
      cy="16"
      r="9"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="16"
      cy="16"
      r="4"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StartLocationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="4" fill={style.mainBlue.blue} />
    <circle
      cx="12"
      cy="12"
      r="8"
      stroke={style.mainBlue.blue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FinishLocationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2 3.6C6.2 3.26863 5.93137 3 5.6 3C5.26863 3 5 3.26863 5 3.6V21.478C5 21.8094 5.26863 22.078 5.6 22.078C5.93137 22.078 6.2 21.8094 6.2 21.478V3.6ZM18.9857 7.5952L18.9857 7.57508L18.9762 4.174C18.9753 3.89815 18.927 3.58954 18.4747 3.43879C16.7006 2.823 14.9783 3.25678 13.2559 3.69056C11.5335 4.12435 9.81114 4.55814 8.03706 3.94232C7.76095 3.83062 7.5376 3.93013 7.53841 4.20597C7.54072 5.04624 7.54245 5.88653 7.54418 6.72681V6.72683C7.54769 8.43472 7.55121 10.1426 7.55962 11.8504C7.56163 12.2594 7.78501 12.4739 8.0612 12.5857C9.83521 13.2015 11.5576 12.7677 13.28 12.3339C15.0024 11.9002 16.7248 11.4664 18.4989 12.0822C18.775 12.1938 18.9982 12.0943 18.9974 11.8184C18.9937 10.4107 18.9897 9.00295 18.9857 7.5952ZM17.9818 4.26657L17.9877 6.37563C17.2198 6.19675 16.5069 6.17031 15.7235 6.24634L15.7206 5.17179L15.7178 4.1373C16.501 4.06134 17.2139 4.08764 17.9818 4.26657ZM8.55144 7.92959L8.55143 7.9293L8.5495 7.2209C9.35578 7.4121 10.1122 7.42894 10.9334 7.33439L10.94 9.73083C10.1188 9.82533 9.36247 9.80851 8.55621 9.61737C8.55449 9.05483 8.55296 8.49225 8.55144 7.92968L8.55144 7.92964V7.92959ZM13.3283 6.7819C12.5351 6.99933 11.7462 7.20445 10.9334 7.33439L10.9275 5.22528C11.7404 5.09532 12.5292 4.89031 13.3224 4.67283L13.3283 6.7819ZM10.9398 9.73094L10.9458 11.871C11.7529 11.7421 12.536 11.5392 13.3235 11.3232L13.3176 9.18307C12.53 9.39903 11.7469 9.60206 10.9398 9.73094ZM13.3371 9.17848L13.3306 6.78203C14.1234 6.56544 14.9113 6.36599 15.7254 6.24669L15.7321 8.6431C14.9181 8.76252 14.13 8.96187 13.3371 9.17848ZM15.7446 8.64138L15.7507 10.7815C16.5289 10.7071 17.238 10.7345 18.0008 10.9124L17.9948 8.7724C17.232 8.59445 16.523 8.56711 15.7446 8.64138Z"
      fill={style.mainBlue.blue}
    />
  </svg>
);

export const MoveIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12ZM4 16C3.44772 16 3 16.4477 3 17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17C21 16.4477 20.5523 16 20 16H4Z"
      fill="#C2C2C2"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05029 6.94922L16.9498 16.8487"
      stroke="#8D8D8D"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9497 6.94922L7.05021 16.8487"
      stroke="#8D8D8D"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddWayPointIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={style.mainYellow.yellow}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7C11.4477 7 11 7.44772 11 8V11H8C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H11V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H13V8C13 7.44772 12.5523 7 12 7Z"
      fill={style.mainYellow.yellow}
    />
  </svg>
);

export const RouteDistanceIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 2L12.324 17.7188C12.2858 17.8027 12.2243 17.8738 12.1469 17.9236C12.0694 17.9735 11.9792 18 11.8871 18C11.795 18 11.7048 17.9735 11.6274 17.9236C11.5499 17.8738 11.4884 17.8027 11.4503 17.7188L8.39449 11.6055L2.28116 8.54974C2.19732 8.51158 2.12622 8.4501 2.07637 8.37264C2.02651 8.29518 2 8.205 2 8.11288C2 8.02076 2.02651 7.93059 2.07637 7.85312C2.12622 7.77566 2.19732 7.71418 2.28116 7.67602L18 2Z"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RouteTimeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 11C17 12.8565 16.2625 14.637 14.9497 15.9497C13.637 17.2625 11.8565 18 10 18C8.14348 18 6.36301 17.2625 5.05025 15.9497C3.7375 14.637 3 12.8565 3 11C3 9.14348 3.7375 7.36301 5.05025 6.05025C6.36301 4.7375 8.14348 4 10 4C11.8565 4 13.637 4.7375 14.9497 6.05025C16.2625 7.36301 17 9.14348 17 11V11Z"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 4L15 6"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1H12"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8V11"
      stroke={style.mainBlue.dodgerBlue}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShareButton = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20"
      r="19"
      stroke={style.mainYellow.yellow}
      strokeWidth="2"
    />
    <path
      d="M30.3718 17.6312L22.414 10.4694C22.0681 10.1579 21.7147 10 21.3636 10C20.8763 10 20.3073 10.3286 20.3073 11.2545V15.6703C17.8785 15.8192 15.6187 16.7481 13.8918 18.3183C12.0269 20.0142 11 22.2623 11 24.6483C11 25.6761 11.1917 26.6855 11.5699 27.6484C11.6526 27.8591 11.874 28 12.1223 28C12.3707 28 12.5919 27.8591 12.6748 27.6484C13.8381 24.6862 16.8598 22.6215 20.3074 22.3764V26.7454C20.3074 27.6712 20.8764 27.9999 21.3636 27.9999H21.3638C21.7147 27.9999 22.0681 27.8421 22.414 27.5307L30.3719 20.3686C30.7769 20.004 30.9998 19.518 30.9998 18.9999C30.9998 18.4819 30.7768 17.9957 30.3718 17.6312Z"
      fill={style.mainYellow.yellow}
      stroke={style.mainYellow.yellow}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SavedRoutesPlaceholder = () => (
  <svg
    width="104"
    height="105"
    viewBox="0 0 104 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52 59.8892L60.3585 62.881C60.5409 62.9459 60.7297 62.978 60.9173 62.978C61.2643 62.978 61.6088 62.8686 61.8973 62.6576C62.342 62.3325 62.5993 61.8069 62.5843 61.2537L62.3401 52.3287L67.7501 45.2512C68.0855 44.8128 68.1845 44.236 68.0145 43.7097C67.8445 43.1835 67.4278 42.7758 66.9003 42.6192L58.3907 40.0946L53.3753 32.7288C53.064 32.2726 52.5496 32 52 32C51.4504 32 50.9359 32.2726 50.6247 32.7288L45.6093 40.0946L37.0996 42.6192C36.5721 42.7758 36.1554 43.1835 35.9854 43.7097C35.8155 44.236 35.9144 44.8134 36.2498 45.2512L41.6598 52.328L41.4156 61.2537C41.4007 61.8069 41.6579 62.3318 42.1026 62.6576C42.5474 62.9826 43.123 63.0665 43.6407 62.881L52 59.8892ZM43.4279 60.833L52 57.765L60.572 60.8332L60.3215 51.6762L65.8811 44.403L57.1386 41.8094L52 34.2625L46.8613 41.8094L38.1188 44.403L43.6784 51.6755L43.4279 60.833Z"
      fill="#C2C2C2"
    />
    <path
      d="M19 55V59C18.0732 58.7408 17.2884 57.9718 17.0642 57C17.0284 56.8448 17.0069 56.6843 17.0014 56.52C17.0005 56.4921 17 56.464 17 56.4359V55H19Z"
      fill="#C2C2C2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52 89.6015L43.3528 78.17C41.7836 77.7122 40.2656 77.1329 38.8097 76.4429C36.3603 78.684 33.4053 80.377 30.1367 81.3288L24 89.4261L17.8633 81.3288C8.69928 78.6602 2 70.166 2 60.1C2 48.3393 11.1449 38.7243 22.6811 38.0391C26.8689 25.7963 38.4138 17 52 17C65.5862 17 77.1311 25.7963 81.3189 38.0391C92.8551 38.7243 102 48.3393 102 60.1C102 70.166 95.3007 78.6602 86.1367 81.3288L80 89.4261L73.8633 81.3288C70.5947 80.377 67.6397 78.684 65.1903 76.4429C63.7344 77.1329 62.2164 77.7122 60.6472 78.17L52 89.6015ZM59.4515 76.4355L60.087 76.2501C72.1625 72.727 81 61.5056 81 48.2C81 32.0611 68.0042 19 52 19C35.9958 19 23 32.0611 23 48.2C23 61.5056 31.8375 72.727 43.913 76.2501L44.5485 76.4355L52 86.2863L59.4515 76.4355ZM66.9673 75.5291C67.0102 75.5053 67.053 75.4814 67.0957 75.4573C69.2081 77.2521 71.6955 78.6144 74.4225 79.4085L75.0577 79.5935L80 86.1149L84.9424 79.5935L85.5775 79.4085C93.9057 76.9833 100 69.2583 100 60.1C100 49.6504 92.0703 41.0755 81.9434 40.0937C82.6325 42.6787 83 45.3961 83 48.2C83 49.1992 82.9533 50.1874 82.8621 51.1626C82.8671 51.1084 82.8721 51.0542 82.8769 51H83.0602C83.731 51 84.2972 51.2602 84.6951 51.5601C85.0953 51.8619 85.4807 52.3199 85.6739 52.9237L85.9594 53.8129H87.2006C89.3697 53.8129 91 55.6305 91 57.6871V66.1242C91 68.1813 89.3707 70 87.2006 70H74.1773C72.0635 72.1779 69.6356 74.0457 66.9673 75.5291ZM75.9588 68H87.2006C88.1891 68 89 67.1554 89 66.1242V57.6871C89 56.6575 88.1891 55.8129 87.2006 55.8129H85.0387C84.7417 55.8129 84.4214 55.5733 84.3297 55.2791L83.7692 53.5338C83.676 53.2411 83.3572 53 83.0602 53H82.6354C82.4283 54.3496 82.1354 55.6706 81.7622 56.9572C83.3433 57.6306 84.4607 59.1823 84.5004 60.9992L84.5012 61.0482L84.5015 61.0991C84.5015 63.5842 82.4851 65.5991 80 65.5991C79.2948 65.599 78.6266 65.4366 78.0325 65.1473C77.3942 66.1384 76.7016 67.0907 75.9588 68ZM78.8652 63.7782C79.2151 63.9212 79.5979 64 79.9992 64C81.6235 63.9996 82.9457 62.7107 82.9984 61.0991C82.9995 61.0659 83 61.0326 83 60.9992C83 59.8224 82.3223 58.8039 81.3353 58.3128C80.6847 60.2252 79.8546 62.0538 78.8652 63.7782ZM22.0566 40.0937C11.9297 41.0755 4 49.6504 4 60.1C4 69.2583 10.0943 76.9833 18.4225 79.4085L19.0577 79.5935L24 86.1149L28.9424 79.5935L29.5775 79.4085C32.3045 78.6144 34.7919 77.2521 36.9043 75.4573C34.6991 74.2176 32.6599 72.7146 30.8286 70.9907C30.8319 70.9938 30.8352 70.9969 30.8385 71H16.3868L17.9312 66.56C18.1314 65.8873 18.5814 65.3406 19.1509 64.9972C18.2655 64.0945 17.6309 62.9453 17.3544 61.6601C15.3662 60.7811 14 58.8181 14 56.52V54.6C14 53.9055 14.2402 53.1713 14.8058 52.6058C15.3713 52.0402 16.1055 51.8 16.8 51.8H17.2V51H21.1231C21.0416 50.0776 21 49.1437 21 48.2C21 45.3962 21.3675 42.6787 22.0566 40.0937ZM21.3646 53H19.2V53.8H16.8C16.32 53.8 16 54.12 16 54.6V56.52C16 58.1937 17.1253 59.6026 18.7135 60.0243C18.8713 60.0662 19.0337 60.0983 19.2 60.12V60.2C19.2 60.5286 19.2321 60.8492 19.2934 61.1588C19.598 62.6988 20.6236 63.967 22.0066 64.6L22.0248 64.6083C22.1472 64.6637 22.2723 64.7141 22.4 64.7593C22.5721 64.8203 22.7488 64.8717 22.9295 64.9131L22.96 64.92L22.4 66.6H20.56C20.2961 66.6 20.0322 66.7633 19.9029 67C19.8754 67.0503 19.854 67.1039 19.84 67.16L19.2 69H28.8L28.7391 68.8251C28.0819 68.0748 27.4599 67.2925 26.8758 66.4807C26.9044 66.5205 26.9332 66.5603 26.9621 66.6H25.6L25.04 64.92L25.0705 64.9131C25.2512 64.8717 25.4279 64.8203 25.6 64.7593C25.6332 64.7475 25.6662 64.7354 25.6991 64.723C23.5223 61.2205 22.0169 57.252 21.3646 53Z"
      fill="#C2C2C2"
    />
  </svg>
);

export const BookmarkIcon = ({
  colorFill = '#ffffff',
}: {
  colorFill?: string;
}) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20"
      r="19"
      stroke={style.mainYellow.yellow}
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 14.2513V29L20 25.1139L13 29V14.2513C13 12.4557 14.567 11 16.5 11H23.5C25.433 11 27 12.4557 27 14.2513Z"
      stroke={style.mainYellow.yellow}
      fill={colorFill}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
